import {Injectable} from '@angular/core';

@Injectable()
export class CodeService  {

    console: boolean = false;
    logPrefix: string = '@core - '+ this.constructor.name;

    constructor(){}

    getDataType(data: any){

        if(typeof data == 'object' && Array.isArray(data)){

            return 'array';
        }
        else if(data == null){

            return null;
        }
        else {

            return (typeof data);
        }
    }

    getDataLength(data: any){

        if(data){

            switch (this.getDataType(data)) {
                case "object":

                    return Object.keys(data).length;

                    break;
                case "array":
                case "string":

                    return data.length;

                    break;
                case "number":

                    return (data.toString()).length;

                    break;
            }

        }

        return 0;
    }

    isObject(data: any) {

        return (this.getDataType(data) == 'object');
    }

    isArray(data: any) {

        return (this.getDataType(data) == 'array');
    }

    isString(data: any) {

        return (this.getDataType(data) == 'string');
    }

    isNumber(data: any) {

        return (this.getDataType(data) == 'number');
    }

    isEmpty(data: any) {

        return !(this.getDataLength(data) > 0);
    }

    sleep(ms) {
        const date = Date.now();
        let currDate = null;
        do {
            currDate = Date.now();
        } while (currDate - date < ms);
    }

    stripHtml(html:string){

        if(!html){
            return "";
        }

        let tmp = document.createElement("DIV");
        tmp.innerHTML = html;

        return tmp.textContent || tmp.innerText || "";
    }

    truncateString(text:string, limit:number, end?:string) {

        if(text && limit && (text.length > limit)){

            if(end == null) end = "&hellip;";

            return text.substring(0, limit) + end;
        }
        return text;
    }

    truncateHtml(html:string, limit:number, end?:string) {

        return this.truncateString(this.stripHtml(html), limit, end);
    }


    unCamelCase(text:string){

        if(text){
            return text.replace(/([a-z0-9])([A-Z])/g, '$1 $2').toLowerCase();
        }
        return '';
    }

    splitCamelCase(text:string){

        return (this.unCamelCase(text)).split(' ');
    }


    findPath(pathPointer:any, path:string){

        if(this.console) console.log( this.logPrefix,  'findPath INIT', pathPointer, path );

        let error = null;
        let pathtTarget = null;

        if(!pathPointer || !this.isObject(pathPointer)){

            error = 'pointerNotValid';
        }
        else {

            let pathSplit = path.trim().split('/');

            if(pathSplit.length){ // > 1

                for (let pathPart of pathSplit) {

                    // Set next pointer
                    if(pathtTarget != null) pathPointer = (pathPointer.hasOwnProperty(pathtTarget)) ? pathPointer[pathtTarget] : false;
                    if(!pathPointer) break; // path error

                    // Set next path target
                    pathtTarget = pathPart.trim();

                    if(pathtTarget) { // default: as object property

                        if (pathtTarget.charAt(0) == '[') { // as array

                            pathtTarget = pathtTarget.replace(/^\[|]$/g, '').trim(); // remove first and last brackets

                            if (pathtTarget.charAt(0) != '{') { // use array numeric key

                                pathtTarget = parseInt(pathtTarget);
                            }
                            else { // find property/value in array with objects rows

                                let rowFilter = JSON.parse(pathtTarget);

                                pathtTarget = false;

                                if (this.isObject(rowFilter)) {

                                    let filterProp = Object.keys(rowFilter)[0];
                                    let filterValue = rowFilter[filterProp];

                                    for (var i = 0; i < pathPointer.length; i++) {

                                        if (pathPointer[i].hasOwnProperty(filterProp) && pathPointer[i][filterProp] == filterValue) {

                                            pathtTarget = i; //(i).toString(); // found
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }

                    if(this.console) console.log( this.logPrefix,  'findPath PART', pathPointer, pathtTarget );
                }
            }

            if(!pathPointer){

                error = 'pathError';
            }
            else if(!pathPointer.hasOwnProperty(pathtTarget)){

                error = 'notFound';
            }
        }

        if(this.console) console.log( this.logPrefix,  'findPath COMPLETE', pathPointer, pathtTarget, error );

        return {
            pointer: pathPointer,
            target: pathtTarget,
            error: error
        };
    }
}


